import { transition } from '@helpers/animation';
import brand from '@helpers/brand';
import { ButtonReset } from '@helpers/global';
import { Device, until } from '@helpers/media';
import styled, { css } from 'styled-components';
const Container = styled.section `
  ${transition('opacity')};

  display: flex;

  &[data-inactive='true'] {
    opacity: 0;
  }
`;
const CarouselButtonStyles = css `
  ${ButtonReset};
  ${transition('background-color', 0.2)};

  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: ${brand.primary.blue.base};
  color: ${brand.white};
  cursor: pointer;
  margin-right: 10px;
  position: relative;
  aspect-ratio: 1;

  @media ${until(Device.Tablet)} {
    width: 37px;
    height: 37px;
  }

  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 15px;
    height: 24px;
    transform: translate(-50%, -50%);

    @media ${until(Device.Tablet)} {
      width: 10px;
      height: 16px;
    }
  }

  &:focus-visible,
  &:hover {
    background-color: ${brand.primary.blue.light};
  }

  &[disabled] {
    background-color: ${brand.primary.blue.light};
    opacity: 0.75;
    pointer-events: none;
  }
`;
const CarouselButtonPrev = styled.button `
  ${CarouselButtonStyles};

  transform: scale(-1);
`;
const CarouselButtonNext = styled.button `
  ${CarouselButtonStyles};
`;
const CarouselButtonsStyles = {
    Container,
    CarouselButtonNext,
    CarouselButtonPrev,
};
export default CarouselButtonsStyles;
